import React, { useState } from 'react';
import Logo from "assets/images/images_new/logo.svg"; 

const MobileAppBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const getStoreUrl = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "https://play.google.com/store/search?q=language+academy&c=apps&hl=en_IN";
    }
    return "https://apps.apple.com/in/app/la-pte/id6443614190";
  };

  const storeUrl = getStoreUrl();

  if (!isVisible) return null;

  return (
    <div className="d-block d-md-none bg-white p-3 shadow-sm" style={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 2147483647,
        borderTop: '1px solid #dee2e6' 
    }}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
            <div>
                <img src={Logo} alt="App Logo" style={{ width: '45px', height: '45px', borderRadius: '8px', objectFit: 'contain' }} />
            </div>
            <div style={{ marginLeft: '10px' }}>
                <h6 className="mb-1 font-weight-bold" style={{ fontSize: '15px' }}>PTE Academic & Core</h6>
                <small className="text-muted" style={{ fontSize: '12px' }}>PTE Exam Practice</small>
            </div>
        </div>
        <div className="d-flex align-items-center">
            <a href={storeUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm text-white px-4 py-2" style={{ backgroundColor: '#20c997', borderColor: '#20c997', borderRadius: '4px', fontSize: '13px',marginRight:"10px" }}>
                Install
            </a>
            <button 
                onClick={() => setIsVisible(false)}
                className="ml-4 border-0 bg-transparent p-0 text-muted"
                style={{ fontSize: '24px', lineHeight: '1' }}
                aria-label="Close"
            >
                &times;
            </button>
        </div>
      </div>
    </div>
  );
};

export default MobileAppBanner;
